import classNames from 'classnames';
import classList from './Toolbar.module.scss';

interface IToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
	dir?: 'start' | 'center' | 'end';
	styled?: boolean;
	alignItems?: 'start' | 'center' | 'right' | 'stretch';
}

/** Компонента для отображения тулбара с возможностью настройки его позиционирования без применения стилей */
const Toolbar: React.FC<IToolbarProps> = (props) => {
	const {
		alignItems = 'start',
		dir = 'left',
		styled = false,
		style,
		children,
		className,
		...otherProps
	} = props;

	const getJustifyContent = () => {
		if (dir === 'center') {
			return dir;
		} else if (dir === 'start') {
			return 'flex-start';
		} else {
			return 'flex-end';
		}
	};

	const classes = classNames(classList.wrapper, className, {
		[classList.styled]: styled,
	});
	const styles: React.CSSProperties = {
		...style,
		alignItems,
		justifyContent: getJustifyContent(),
	};

	return (
		<div {...otherProps} className={classes} style={styles}>
			{children}
		</div>
	);
};

export default Toolbar;
